import dayjs from 'dayjs'
import { GET_BIRTHDAY_FROM_ID, GET_GENDER_FROM_ID } from './tools'

/**
 * @desc 大于等于最小天数
 * @param {object} options
 * @param {string} options.idNo
 * @param {string} options.minDay
 * @param {boolean} options.isFromToday
 * */
export function isOlderThenMinDay (options = {}) {
  const { idNo, minDay, isFromToday } = options
  if (!idNo || !minDay) {
    return false
  }
  // 取投保日日期，即今日
  let calcDate = dayjs().hour(0).minute(0).second(0).millisecond(0)
  // 按生效日期开始算，生效日期为投保下单的第二天
  if (!isFromToday) {
    calcDate = calcDate.add(1, 'day')
  }
  const minDate = calcDate.subtract(minDay, 'day')
  const birthday = dayjs(GET_BIRTHDAY_FROM_ID(idNo).join('-'))
  // 返回生日是否在最小天数及之前出生
  return !birthday.isAfter(minDate)
}

/**
 * @desc 大于等于最小年龄
 * @param {object} options
 * @param {string} options.idNo
 * @param {string} options.minAge
 * @param {boolean} options.isFromToday
 * */
export function isOlderThenMinAge (options = {}) {
  const { idNo, minAge, isFromToday } = options
  if (!idNo || !minAge) {
    return false
  }

  // 取投保日日期，即今日
  let calcDate = dayjs().hour(0).minute(0).second(0).millisecond(0)
  // 按生效日期开始算，生效日期为投保下单的第二天
  if (!isFromToday) {
    calcDate = calcDate.add(1, 'day')
  }
  // 最小年龄，周岁计算，在周岁生日及之前出生即满足
  const minDate = calcDate.subtract(minAge, 'year')
  const birthday = dayjs(GET_BIRTHDAY_FROM_ID(idNo).join('-'))
  // 返回生日是否在最小天数及之前出生
  return !birthday.isAfter(minDate)
}

/**
 * @desc 小于等于最大年龄
 * @param {object} options
 * @param {string} options.idNo
 * @param {string} options.maxAge
 * @param {boolean} options.isFromToday
 * */
export function isYoungerThenMaxAge (options = {}) {
  const { idNo, maxAge, isFromToday } = options
  if (!idNo || !maxAge) {
    return false
  }
  // 取投保日日期，即今日
  let calcDate = dayjs().hour(0).minute(0).second(0).millisecond(0)
  // 按生效日期开始算，生效日期为投保下单的第二天
  if (!isFromToday) {
    calcDate = calcDate.add(1, 'day')
  }
  // 最小年龄，周岁计算，小于下一个周岁生日即可
  const maxDate = calcDate.subtract(parseInt(maxAge) + 1, 'year')
  const birthday = dayjs(GET_BIRTHDAY_FROM_ID(idNo).join('-'))
  // 返回生日是否在最小天数及之前出生
  return birthday.isAfter(maxDate)
}

/**
 * @desc 当被保人年龄小于18周岁时，被保人必须为投保人的子女
 * @param {object} options
 * @param {string} options.idNo
 * @param {string} options.relation
 * @param {boolean} options.isFromToday
 * */
export function checkChildrenAge (options = {}) {
  const { idNo, relation, isFromToday } = options
  let isOlderThen18 = isOlderThenMinAge({ idNo, minAge: 18, isFromToday })
  return isOlderThen18 || !isOlderThen18 && relation === 'children'
}

/**
 * @desc 被保人是投保人子女时，被保人必须小于投保人18岁以上
 * 被保人是投保人父母时，被保人必须大于投保人18岁以上
 *
 * 年龄差必须在特定值之内，默认计算18岁年龄差
 *
 * @param {object} options
 * @param {string} options.olderId
 * @param {string} options.youngerId
 * @param {string} options.gap
 *
 * */
export function checkAgeGap (options = { gap: 18 }) {
  const { olderId, youngerId, gap } = options
  const olderBirthGapBefore = dayjs(GET_BIRTHDAY_FROM_ID(olderId).join('-')).add(gap, 'year')
  const youngerBirth = dayjs(GET_BIRTHDAY_FROM_ID(youngerId).join('-'))
  return !youngerBirth.isBefore(olderBirthGapBefore)
}
export function checkAgeGap2 (options = { gap: 18 }) {
  const { olderId, youngerId, gap } = options
  const olderBirthGapBefore = dayjs(olderId).add(gap, 'year')
  const youngerBirth = dayjs(youngerId)
  return !youngerBirth.isBefore(olderBirthGapBefore)
}
/**
 * @desc 关系为配偶时，被保人与投保人性别不能一直
 * @param {object} options
 * @param {string} options.appntId
 * @param {string} options.insuredId
 * */
export function checkSpouseGender (options = {}) {
  const { appntId, insuredId } = options
  const appntGender = GET_GENDER_FROM_ID(appntId)
  const insuredGender = GET_GENDER_FROM_ID(insuredId)
  return appntGender !== insuredGender
}

/**
 * @desc 关系为配偶时，校验年龄是否到达结婚年龄
 * @param {object} options
 * @param {string} options.idNo
 * @param {boolean} options.isFromToday
 * */
export function checkMarriedAge (options = {}) {
  const { idNo, isFromToday } = options
  const gender = GET_GENDER_FROM_ID(idNo)
  // 男性必须大于22周岁
  if (gender === '1') {
    return isOlderThenMinAge({ idNo, minAge: 22, isFromToday })
  }
  // 女性必须大于20周岁
  if (gender === '2') {
    return isOlderThenMinAge({ idNo, minAge: 20, isFromToday })
  }
}
